const postConfig = {
  method: 'POST',
  credentials: 'same-origin',
  headers: {
    'Content-Type': 'application/json;',
  },
};

export default postConfig;
